import { Button, Card, Col, Form, Row } from 'react-bootstrap';

export const EVENT_TYPE_OPTIONS = [
  'Capacitacion Integral Progresiva',
  'Asamblea Nacional',
  'Encuentro de Alianza Matrimonial',
  'Otro',
];

const paymentTypeOptions = [
  { value: 'free', label: 'Gratis' },
  { value: 'offline', label: 'Pago fuera del sitio web' },
  { value: 'stripe', label: 'Pagar en sitio web (Stripe)' },
];

const modalityOptions = [
  { value: 'presencial', label: 'Presencial' },
  { value: 'online', label: 'En linea' },
  { value: 'hybrid', label: 'Hibrido' },
];

const countModeOptions = [
  { value: 'membership', label: 'Contar por membresia' },
  { value: 'people', label: 'Contar por personas' },
];

const sessionModeOptions = [
  { value: 'single', label: '1 sesion' },
  { value: 'multiple', label: 'Multiples sesiones' },
];

const visibilityOptions = [
  { value: 1, label: 'Nacional' },
  { value: 2, label: 'Regional' },
  { value: 3, label: 'Diocesis' },
  { value: 4, label: 'Comunidad' },
];

function EventFormFields({
  form,
  org,
  fixedEventType,
  fixedVisibilityLevel,
  fixedRegionId,
  fixedDiocesisId,
  fixedComunidadId,
  onFieldChange,
  onVisibilityLevelChange,
  onRegionChange,
  onDiocesisChange,
  onSessionModeChange,
  onAddSession,
  onRemoveSession,
  onSessionChange,
  readOnlyType = false,
}) {
  if (!form) {
    return null;
  }

  const regiones = org?.regiones || [];
  const shouldShowTypeSelect = !fixedEventType;
  const visibilityLevel = parseInt(fixedVisibilityLevel || form.visibilityLevel);
  const shouldShowVisibilitySelect = !fixedVisibilityLevel;
  const shouldShowRegion = visibilityLevel >= 2 && !fixedRegionId;
  const shouldShowDiocesis = visibilityLevel >= 3 && !fixedDiocesisId;
  const shouldShowComunidad = visibilityLevel >= 4 && !fixedComunidadId;
  const paymentOptions = visibilityLevel === 1
    ? paymentTypeOptions
    : paymentTypeOptions.filter((option) => option.value !== 'stripe');
  const diocesisByRegion = (() => {
    const selectedRegion = fixedRegionId ? String(fixedRegionId) : form.regionId;
    if (!selectedRegion) {
      return [];
    }
    return (org?.diocesis || []).filter((item) => parseInt(item.region_id) === parseInt(selectedRegion));
  })();
  const comunidadesByDiocesis = (() => {
    const selectedDiocesis = fixedDiocesisId ? String(fixedDiocesisId) : form.diocesisId;
    if (!selectedDiocesis) {
      return [];
    }
    return (org?.comunidades || []).filter((item) => parseInt(item.diocesis_id) === parseInt(selectedDiocesis));
  })();

  return (
    <Row className="g-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label>Titulo</Form.Label>
          <Form.Control required value={form.title} onChange={(e) => onFieldChange('title', e.target.value)} />
        </Form.Group>
      </Col>

      {shouldShowTypeSelect ? (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Tipo</Form.Label>
            <Form.Select value={form.eventType} onChange={(e) => onFieldChange('eventType', e.target.value)}>
              {EVENT_TYPE_OPTIONS.map((option) => <option key={`new-event-type-${option}`} value={option}>{option}</option>)}
            </Form.Select>
          </Form.Group>
        </Col>
      ) : readOnlyType ? (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Tipo</Form.Label>
            <Form.Control required value={form.eventType || fixedEventType || ''} disabled readOnly />
          </Form.Group>
        </Col>
      ) : null}

      {shouldShowVisibilitySelect && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Nivel</Form.Label>
            <Form.Select value={form.visibilityLevel} onChange={(e) => onVisibilityLevelChange(e.target.value)}>
              {visibilityOptions.map((option) => <option key={`level-${option.value}`} value={option.value}>{option.label}</option>)}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

      {shouldShowRegion && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Region</Form.Label>
            <Form.Select value={form.regionId} onChange={(e) => onRegionChange(e.target.value)} required>
              <option value="">Selecciona una region</option>
              {regiones.map((region) => (
                <option key={`region-option-${region.region_id}`} value={region.region_id}>{region.label}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

      {shouldShowDiocesis && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Diocesis</Form.Label>
            <Form.Select value={form.diocesisId} onChange={(e) => onDiocesisChange(e.target.value)} disabled={!form.regionId} required>
              <option value="">Selecciona una diocesis</option>
              {diocesisByRegion.map((diocesis) => (
                <option key={`diocesis-option-${diocesis.diocesis_id}`} value={diocesis.diocesis_id}>{diocesis.label}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

      {shouldShowComunidad && (
        <Col md={3}>
          <Form.Group>
            <Form.Label>Comunidad</Form.Label>
            <Form.Select value={form.comunidadId} onChange={(e) => onFieldChange('comunidadId', e.target.value)} disabled={!form.diocesisId} required>
              <option value="">Selecciona una comunidad</option>
              {comunidadesByDiocesis.map((comunidad) => (
                <option key={`comunidad-option-${comunidad.comunidad_id}`} value={comunidad.comunidad_id}>{comunidad.label}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
      )}

      <Col md={4}>
        <Form.Group>
          <Form.Label>Modalidad</Form.Label>
          <Form.Select value={form.modality} onChange={(e) => onFieldChange('modality', e.target.value)}>
            {modalityOptions.map((option) => <option key={`modality-${option.value}`} value={option.value}>{option.label}</option>)}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label>Pago</Form.Label>
          <Form.Select value={form.paymentType} onChange={(e) => onFieldChange('paymentType', e.target.value)}>
            {paymentOptions.map((option) => <option key={`payment-${option.value}`} value={option.value}>{option.label}</option>)}
          </Form.Select>
        </Form.Group>
      </Col>
      <Col md={4}>
        <Form.Group>
          <Form.Label>Conteo de cupo</Form.Label>
          <Form.Select value={form.registrationCountMode} onChange={(e) => onFieldChange('registrationCountMode', e.target.value)}>
            {countModeOptions.map((option) => <option key={`count-${option.value}`} value={option.value}>{option.label}</option>)}
          </Form.Select>
        </Form.Group>
      </Col>

      <Col md={4}>
        <Form.Group>
          <Form.Label>Sesiones</Form.Label>
          <Form.Select value={form.sessionMode} onChange={(e) => onSessionModeChange(e.target.value)}>
            {sessionModeOptions.map((option) => <option key={`session-mode-${option.value}`} value={option.value}>{option.label}</option>)}
          </Form.Select>
        </Form.Group>
      </Col>

      {form.sessionMode === 'single' && (
        <>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Hora inicio</Form.Label>
              <Form.Control type="time" required value={form.singleSessionStartTime} onChange={(e) => onFieldChange('singleSessionStartTime', e.target.value)} />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Hora fin</Form.Label>
              <Form.Control type="time" required value={form.singleSessionEndTime} onChange={(e) => onFieldChange('singleSessionEndTime', e.target.value)} />
            </Form.Group>
          </Col>
        </>
      )}

      <Col md={3}>
        <Form.Group>
          <Form.Label>Ciclo</Form.Label>
          <Form.Control type="number" value={form.cycleYear} onChange={(e) => onFieldChange('cycleYear', e.target.value)} required />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Inicio</Form.Label>
          <Form.Control type="date" value={form.startsOn} onChange={(e) => onFieldChange('startsOn', e.target.value)} required />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Fin</Form.Label>
          <Form.Control type="date" min={form.startsOn} value={form.endsOn} onChange={(e) => onFieldChange('endsOn', e.target.value)} required />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group>
          <Form.Label>Cupo</Form.Label>
          <Form.Control type="number" value={form.capacityLimit} onChange={(e) => onFieldChange('capacityLimit', e.target.value)} placeholder="Opcional" />
        </Form.Group>
      </Col>

      {form.paymentType !== 'free' && (
        <>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Monto</Form.Label>
              <Form.Control type="number" step="0.01" value={form.feeAmount} onChange={(e) => onFieldChange('feeAmount', e.target.value)} required />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Moneda</Form.Label>
              <Form.Control value={form.currency} onChange={(e) => onFieldChange('currency', e.target.value)} />
            </Form.Group>
          </Col>
        </>
      )}

      <Col md={6}>
        <Form.Group>
          <Form.Label>Lugar</Form.Label>
          <Form.Control value={form.locationName} onChange={(e) => onFieldChange('locationName', e.target.value)} placeholder="Nombre del lugar" />
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group>
          <Form.Label>Direccion</Form.Label>
          <Form.Control value={form.locationAddress} onChange={(e) => onFieldChange('locationAddress', e.target.value)} placeholder="Direccion" />
        </Form.Group>
      </Col>
      <Col md={12}>
        <Form.Group>
          <Form.Label>Link de sesion (Zoom/Meet)</Form.Label>
          <Form.Control value={form.meetingUrl} onChange={(e) => onFieldChange('meetingUrl', e.target.value)} placeholder="https://..." />
        </Form.Group>
      </Col>
      <Col md={12}>
        <Form.Group>
          <Form.Label>Descripcion</Form.Label>
          <Form.Control as="textarea" rows={3} value={form.description} onChange={(e) => onFieldChange('description', e.target.value)} />
        </Form.Group>
      </Col>

      {form.sessionMode === 'single' ? null : (
        <Col md={12}>
          <hr className="my-4" />
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="mb-0">Sesiones</h5>
            {onAddSession && <Button type="button" variant="outline-primary" size="sm" onClick={onAddSession}>Agregar sesion</Button>}
          </div>

          {(form.sessions || []).map((session, index) => (
            <Card className="mb-3" key={`session-row-${index}`}>
              <Card.Body>
                <Row className="g-3 align-items-end">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Fecha</Form.Label>
                      <Form.Control type="date" value={session.sessionDate} onChange={(e) => onSessionChange(index, 'sessionDate', e.target.value)} required />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Inicio</Form.Label>
                      <Form.Control type="time" value={session.startTime} onChange={(e) => onSessionChange(index, 'startTime', e.target.value)} required />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Fin</Form.Label>
                      <Form.Control type="time" value={session.endTime} onChange={(e) => onSessionChange(index, 'endTime', e.target.value)} required />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Lugar sesion</Form.Label>
                      <Form.Control value={session.locationName} onChange={(e) => onSessionChange(index, 'locationName', e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={1} className="text-end">
                    {onRemoveSession && <Button type="button" variant="outline-danger" size="sm" onClick={() => onRemoveSession(index)}>X</Button>}
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Direccion sesion</Form.Label>
                      <Form.Control value={session.locationAddress} onChange={(e) => onSessionChange(index, 'locationAddress', e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Link sesion</Form.Label>
                      <Form.Control value={session.meetingUrl} onChange={(e) => onSessionChange(index, 'meetingUrl', e.target.value)} placeholder="https://..." />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          ))}
        </Col>
      )}
    </Row>
  );
}

export default EventFormFields;